import { render, staticRenderFns } from "./StockLocations.vue?vue&type=template&id=d0db7fb4&"
import script from "./StockLocations.vue?vue&type=script&lang=js&"
export * from "./StockLocations.vue?vue&type=script&lang=js&"
import style0 from "./StockLocations.vue?vue&type=style&index=0&id=d0db7fb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports